/*
 * ============================================================
 * PŮVODNÍ KÓD (zakomentován 2026-07, nahrazen novou verzí níže)
 * ============================================================
 *
 * document.addEventListener('DOMContentLoaded', function () {
 *   var PRICE_PER_M2 = 890;
 *   var BOX_M2 = {
 *     'lvt-dryback-plank': 4.55, 'lvt-rigid-plank': 2.20,
 *     'lvt-dryback-tile': 4.18, 'lvt-rigid-tile': 1.67,
 *     'lvt-herringbone': 3.60, 'spc-click': 2.42
 *   };
 *   var COLLECTION_URL = { ... };
 *   var WASTE_HINTS = { ... };
 *   document.querySelectorAll('[data-flowik-calc]').forEach(function (calc) {
 *     ... form submit approach ...
 *   });
 * });
 * ============================================================
 */

(function () {
  'use strict';

  /* ── Formátování čísel ── */
  function fmtM2(val) {
    return val.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²';
  }
  function fmtKc(val) {
    return Math.round(val).toLocaleString('cs-CZ') + ' Kč';
  }

  /* ── Inicializace jedné instance kalkulačky ── */
  function initCalc(el) {
    var modeButtons  = el.querySelectorAll('[data-calc-mode]');
    var lengthEl     = el.querySelector('[data-calc-length]');
    var widthEl      = el.querySelector('[data-calc-width]');
    var sqmEl        = el.querySelector('[data-calc-sqm]');
    var wasteEl      = el.querySelector('[data-calc-waste]');
    var wasteValueEl = el.querySelector('[data-calc-waste-value]');
    var errorEl      = el.querySelector('[data-calc-error]');
    var resultEl     = el.querySelector('[data-calc-result]');
    var resArea      = el.querySelector('[data-res-area]');
    var resRecom     = el.querySelector('[data-res-recommended]');
    var resPriceEx   = el.querySelector('[data-res-price-ex]');
    var resPriceInc  = el.querySelector('[data-res-price-inc]');
    var ctaEl        = el.querySelector('[data-calc-cta]');
    var productRadios = el.querySelectorAll('input[name="calc_product"]');

    /* Preset z data-atributů (produktová stránka) */
    var presetProduct  = el.dataset.presetProduct  || null;
    var presetPrice    = parseFloat(el.dataset.presetPrice)    || null;
    var presetM2PerBox = parseFloat(el.dataset.presetM2PerBox) || null;

    /* Standalone (homepage): výsledek i CTA jsou viditelné pořád, CTA se jen odemyká */
    var standalone = el.hasAttribute('data-flowik-calc-standalone');
    var ctaHint    = el.querySelector('[data-calc-cta-hint]');

    var mode = 'dimensions';

    function setCtaEnabled(on) {
      if (ctaEl) {
        ctaEl.classList.toggle('is-disabled', !on);
        if (on) { ctaEl.removeAttribute('aria-disabled'); }
        else    { ctaEl.setAttribute('aria-disabled', 'true'); }
      }
      if (ctaHint) ctaHint.classList.toggle('is-hidden', on);
    }

    /* Vynuluje hodnoty na pomlčky a zamkne CTA (jen standalone) */
    function resetResult() {
      [resArea, resRecom, resPriceEx, resPriceInc].forEach(function (span) {
        if (span) span.textContent = '—';
      });
      setCtaEnabled(false);
    }

    /* ── Zjistí aktivní produkt ── */
    function getProduct() {
      if (presetPrice && presetM2PerBox) {
        return { price: presetPrice, m2PerBox: presetM2PerBox, key: presetProduct || 'custom' };
      }
      var checked = el.querySelector('input[name="calc_product"]:checked');
      if (!checked) return null;
      return {
        price:    parseFloat(checked.dataset.price),
        m2PerBox: parseFloat(checked.dataset.m2PerBox),
        key:      checked.value
      };
    }

    /* ── Zjistí zadanou plochu ── */
    function getM2() {
      if (mode === 'direct') {
        var v = sqmEl ? parseFloat(sqmEl.value) : NaN;
        return isNaN(v) ? null : v;
      }
      var l = lengthEl ? parseFloat(lengthEl.value) : NaN;
      var w = widthEl  ? parseFloat(widthEl.value)  : NaN;
      if (isNaN(l) || isNaN(w)) return null;
      return l * w;
    }

    /* ── Validace ── */
    function validate(m2) {
      if (mode === 'dimensions') {
        var l = lengthEl ? parseFloat(lengthEl.value) : NaN;
        var w = widthEl  ? parseFloat(widthEl.value)  : NaN;
        if ((!isNaN(l) && l === 0) || (!isNaN(w) && w === 0)) {
          return 'Zadejte prosím rozměry místnosti.';
        }
      }
      if (m2 < 5)   return 'Minimální objednávka je 5 m².\nPro menší plochy doporučujeme nejdřív objednat vzorek.';
      if (m2 > 500) return 'Pro objednávky nad 500 m² nás kontaktujte prosím přes kontaktní formulář.';
      return null;
    }

    /* ── Zobrazení chyby ── */
    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('is-hidden'); }
      if (standalone) { resetResult(); return; }
      if (resultEl) resultEl.classList.add('is-hidden');
    }

    /* ── Zobrazení výsledku ── */
    function showResult(area, finalM2, boxes, priceEx, priceInc, product) {
      if (resArea)     resArea.textContent     = fmtM2(area);
      if (resRecom)    resRecom.textContent    = fmtM2(finalM2) + ' (' + boxes + ' bal.)';
      if (resPriceEx)  resPriceEx.textContent  = fmtKc(priceEx);
      if (resPriceInc) resPriceInc.textContent = fmtKc(priceInc);
      if (errorEl)     errorEl.classList.add('is-hidden');
      if (resultEl)    resultEl.classList.remove('is-hidden');
      setCtaEnabled(true);

      /* Aktualizuj CTA odkaz */
      if (ctaEl) {
        var base = (ctaEl.getAttribute('href') || '/collections/vsechny-dekory').split('?')[0];
        ctaEl.setAttribute('href', base + '?produkt=' + product.key + '&baleni=' + boxes);
      }

      /* Předej data produktové stránce přes sessionStorage */
      try {
        sessionStorage.setItem('flowik_calc_boxes', boxes);
        sessionStorage.setItem('flowik_calc_type', product.key);
      } catch (e) {}

      /* Propiš počet balení do horního jednoduchého výběru množství (stejná stránka) */
      var syncTargetId = el.dataset.syncQtyInput;
      if (syncTargetId) {
        var syncInput = document.getElementById(syncTargetId);
        if (syncInput) {
          syncInput.value = boxes;
          syncInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    }

    /* ── Hlavní výpočet ── */
    function recalculate() {
      var waste = wasteEl ? (parseInt(wasteEl.value) || 0) : 5;
      if (wasteValueEl && wasteEl) wasteValueEl.textContent = wasteEl.value + ' %';

      var m2 = getM2();

      if (m2 === null) {
        if (errorEl) errorEl.classList.add('is-hidden');
        if (standalone) { resetResult(); return; }
        if (resultEl) resultEl.classList.add('is-hidden');
        return;
      }

      var err = validate(m2);
      if (err) { showError(err); return; }

      var product = getProduct();
      if (!product) return;

      var m2WithWaste = m2 * (1 + waste / 100);
      var boxes       = Math.ceil(m2WithWaste / product.m2PerBox);
      var finalM2     = boxes * product.m2PerBox;
      /* TODO: po registraci k DPH vrátit rozpad ceny (priceEx = price / 1.21) */
      var price       = finalM2 * product.price;

      showResult(m2, finalM2, boxes, price, price, product);
    }

    /* ── Přepínač módu (Délka×šířka / Znám m²) ── */
    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = this.dataset.calcMode;
        modeButtons.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        el.querySelectorAll('[data-calc-input-mode]').forEach(function (div) {
          div.classList.toggle('is-hidden', div.dataset.calcInputMode !== mode);
        });
        recalculate();
      });
    });

    /* ── Eventy na vstupy ── */
    productRadios.forEach(function (r) { r.addEventListener('change', recalculate); });
    [lengthEl, widthEl, sqmEl].forEach(function (inp) {
      if (inp) inp.addEventListener('input', recalculate);
    });
    if (wasteEl) wasteEl.addEventListener('input', recalculate);

    /* Zamčené CTA nesmí nikam vést (i při fokusu klávesnicí) */
    if (ctaEl) {
      ctaEl.addEventListener('click', function (e) {
        if (ctaEl.classList.contains('is-disabled')) e.preventDefault();
      });
    }

    /* Počáteční stav */
    recalculate();
  }

  /* ── Bootstrap ── */
  function init() {
    document.querySelectorAll('.flowik-calc').forEach(initCalc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
